export interface TeamVisual {
  primary: string;
  accent: string;
  logoKey: string;
}

const teamVisuals: Record<string, TeamVisual> = {
  ARI: { primary: "#97233F", accent: "#FFB612", logoKey: "ari" },
  ATL: { primary: "#A71930", accent: "#000000", logoKey: "atl" },
  BAL: { primary: "#241773", accent: "#9E7C0C", logoKey: "bal" },
  BUF: { primary: "#00338D", accent: "#C60C30", logoKey: "buf" },
  CAR: { primary: "#0085CA", accent: "#101820", logoKey: "car" },
  CHI: { primary: "#0B162A", accent: "#C83803", logoKey: "chi" },
  CIN: { primary: "#FB4F14", accent: "#000000", logoKey: "cin" },
  CLE: { primary: "#311D00", accent: "#FF3C00", logoKey: "cle" },
  DAL: { primary: "#003594", accent: "#869397", logoKey: "dal" },
  DEN: { primary: "#FB4F14", accent: "#002244", logoKey: "den" },
  DET: { primary: "#0076B6", accent: "#B0B7BC", logoKey: "det" },
  GB: { primary: "#203731", accent: "#FFB612", logoKey: "gb" },
  HOU: { primary: "#03202F", accent: "#A71930", logoKey: "hou" },
  IND: { primary: "#002C5F", accent: "#A2AAAD", logoKey: "ind" },
  JAX: { primary: "#006778", accent: "#D7A22A", logoKey: "jax" },
  KC: { primary: "#E31837", accent: "#FFB81C", logoKey: "kc" },
  LV: { primary: "#000000", accent: "#A5ACAF", logoKey: "lv" },
  LAC: { primary: "#0080C6", accent: "#FFC20E", logoKey: "lac" },
  LAR: { primary: "#003594", accent: "#FFA300", logoKey: "lar" },
  MIA: { primary: "#008E97", accent: "#FC4C02", logoKey: "mia" },
  MIN: { primary: "#4F2683", accent: "#FFC62F", logoKey: "min" },
  NE: { primary: "#002244", accent: "#C60C30", logoKey: "ne" },
  NO: { primary: "#D3BC8D", accent: "#101820", logoKey: "no" },
  NYG: { primary: "#0B2265", accent: "#A71930", logoKey: "nyg" },
  NYJ: { primary: "#125740", accent: "#000000", logoKey: "nyj" },
  PHI: { primary: "#004C54", accent: "#A5ACAF", logoKey: "phi" },
  PIT: { primary: "#FFB612", accent: "#101820", logoKey: "pit" },
  SEA: { primary: "#002244", accent: "#69BE28", logoKey: "sea" },
  SF: { primary: "#AA0000", accent: "#B3995D", logoKey: "sf" },
  TB: { primary: "#D50A0A", accent: "#FF7900", logoKey: "tb" },
  TEN: { primary: "#0C2340", accent: "#4B92DB", logoKey: "ten" },
  WAS: { primary: "#5A1414", accent: "#FFB612", logoKey: "wsh" },
  WSH: { primary: "#5A1414", accent: "#FFB612", logoKey: "wsh" },
};

const fallback: TeamVisual = {
  primary: "#0A2342",
  accent: "#6C8CB5",
  logoKey: "nfl",
};

export function getTeamVisual(abbr: string): TeamVisual {
  return teamVisuals[abbr.toUpperCase()] ?? fallback;
}

export function getTeamLogoUrl(abbr: string): string {
  const visual = getTeamVisual(abbr);

  if (visual.logoKey === "nfl") {
    return "";
  }

  return `https://a.espncdn.com/i/teamlogos/nfl/500/${visual.logoKey}.png`;
}

